import { useEffect, useReducer, createContext, useContext } from 'react';

import ProductsList from './ProductsList';
import BasketDisplay from './BasketDisplay';

/* Erschaffe einen Context außerhalb der Komponente. In createContext()
kann ein Startwert eingegeben werden, das ist meist aber nicht sinnvoll
bzw. möglich. Also leer lassen oder explizit null verwenden.
Wenn man den eigenen Hook unten verwendet, muss der Kontext nicht exportiert werden. */
const BasketDispatchContext = createContext(null);

/* Eigener Hook, der das Ex- und Importieren des Kontextes
erspart. */
export function useBasketDispatchContext() {
  return useContext(BasketDispatchContext);
}

export default function Shop() {
  const [basket, basketDispatch] = useReducer(
    basketReducer,
    null, // Startwert für basket, wenn keine Funktion an dritter Stelle folgt
    getInitialBasket // Optional: Funktion, die den Startwert zurückgibt
  );

  useEffect(() => {
    localStorage.setItem('basket', JSON.stringify(basket));
  }, [basket]);

  return (
    <div className="shop">
      {/*
  	Der value des Kontext kann innerhalb der Kind-Komponenten und
  	deren Kind-Komponenten verwendet werden.
  	*/}
      <BasketDispatchContext.Provider value={basketDispatch}>
        <ProductsList />
        <BasketDisplay basket={basket} />
      </BasketDispatchContext.Provider>
    </div>
  );
}

function basketReducer(basket, message) {
  const productNotInBasket = !basket.some(({ id }) => id === message.id);

  switch (message.type) {
    /*
	basket enthält den aktuellen state. Dieser sollte nie
	direkt manipuliert werden, etwa mit basket.push(), sondern
	stattdessen sollte man aus der Reducer-Funktion einen
	veränderte Kopie des states zurückgeben. Stichwort "Immutability",
	d.h. "Mutationen" von Daten vermeiden und stattdessen
	veränderte Kopien verwenden.
	*/
    case 'add':
      if (productNotInBasket) {
        return [...basket, { id: message.id, amount: 1 }];
      }

      return basket.map((product) => {
        /* Um Mutationen des Original-Arrays bzw. des Objektes im
      	Original-Array zu vermeiden, nutzen wir Objekt-Spread,
       	um eine veränderte Kopie des Produkt-Objektes in den
       	neuen Array zu legen. */
        if (product.id === message.id) {
          return { id: product.id, amount: product.amount + 1 };
        }
        return product;
      });

    case 'subtract':
      return basket.map((product) => {
        if (product.id === message.id) {
          return {
            id: product.id,
            amount: product.amount - 1 < 0 ? 0 : product.amount - 1,
          };
        }
        return product;
      });

    case 'remove':
      return basket.filter((product) => product.id !== message.id);

    case 'emptyBasket':
      return [];

    default:
      return basket;
  }
}

function getInitialBasket() {
  const oldBasket = JSON.parse(localStorage.getItem('basket'));

  return Array.isArray(oldBasket) ? oldBasket : [];
}
